import { AxiosResponse } from "axios";

import { Shipment } from "../models/shipments";

import API from "../api";

import { ShipmentDocument } from "../models/shipment.document";

const ROUTE_NAME = "shipment/documents";

const ShipmentDocumentService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },

  async getById(id: number, options?: any): Promise<AxiosResponse<ShipmentDocument>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<ShipmentDocument[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },

  async create(shipment: any): Promise<AxiosResponse<ShipmentDocument>> {
    return await API.post(`/${ROUTE_NAME}`, shipment);
  },
  async update(id: number, agent: any): Promise<AxiosResponse<ShipmentDocument>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, agent);
  },
  async clear(id: number | undefined, agent: any): Promise<AxiosResponse<ShipmentDocument>> {
    return await API.put(`/${ROUTE_NAME}/clear/${id}`, agent);
  },

  async createMultiple(payload: any): Promise<AxiosResponse<ShipmentDocument>> {
    return await API.post(`/${ROUTE_NAME}/create/multiple`, payload);
  },

  async removeArchive(
    documentId: number,
    archiveId: number
  ): Promise<AxiosResponse<boolean>> {
    return await API.delete(`/${ROUTE_NAME}/archive/remove/${documentId}/${archiveId}`);
  },

  async updateListByShipmentId(
    shipmentId: number,
    documents?: ShipmentDocument[]
  ): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/list/${shipmentId}`, documents);
  },
};

export default ShipmentDocumentService;
